import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { IndividualCustomerDto } from '@/api/generated';
import { useCustomerUpdateMutationOptions } from '@/views/customers/status/useCustomerMutationOptions.util.ts';

type Req = {
  customerId: number;
  data: IndividualCustomerDto;
};

type Return = {
  isUpdatingIndividualCustomer: boolean;
  updateIndividualCustomer: (req: Req) => Promise<void>;
};

export const useUpdateIndividualCustomer = (): Return => {
  const { customersApi } = useApiClient();
  const updateOptions = useCustomerUpdateMutationOptions();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    ...updateOptions,
    mutationFn: async req => {
      const res = await customersApi.updateIndividualCustomer(req.customerId, req.data);

      return res.data;
    },
  });

  return {
    isUpdatingIndividualCustomer: isPending,
    updateIndividualCustomer: mutateAsync,
  };
};
